/* projects/common/components/loader/loader.component.scss */
.loader .line {
  width: 1px;
  height: 12px;
  background: #000;
  margin: 0 1px;
  display: inline-block;
  animation: opacity-2 1000ms infinite ease-in-out;
}
.loader .line-1 {
  animation-delay: 800ms;
}
.loader .line-2 {
  animation-delay: 600ms;
}
.loader .line-3 {
  animation-delay: 400ms;
}
.loader .line-4 {
  animation-delay: 200ms;
}
.loader .line-6 {
  animation-delay: 200ms;
}
.loader .line-7 {
  animation-delay: 400ms;
}
.loader .line-8 {
  animation-delay: 600ms;
}
.loader .line-9 {
  animation-delay: 800ms;
}
@keyframes opacity-2 {
  0% {
    opacity: 1;
    height: 15px;
  }
  50% {
    opacity: 0;
    height: 12px;
  }
  100% {
    opacity: 1;
    height: 15px;
  }
}
/*# sourceMappingURL=loader.component-EVM3RVYG.css.map */
